import { api } from "@/lib/api-client"

// Audit Trail Types
export type AuditEntry = {
  id: string
  timestamp: string
  action: string
  resource_type: string
  resource_id: string
  user_id: string
  user_email: string | null
  changes: {
    field?: string
    before?: unknown
    after?: unknown
    updates?: Record<string, boolean>
    count?: number
    updated_fields?: string[]
    fields?: Record<string, { before: unknown; after: unknown }>
  }
  metadata: Record<string, unknown>
}

export type AuditTrailResponse = {
  entries: AuditEntry[]
  total: number
  limit: number
  offset: number
}

export type AuditStatsResponse = {
  stats: Array<{
    action: string
    resource_type: string
    count: number
  }>
}

export type AuditTrailFilters = {
  resource_type?: string
  resource_id?: string
  user_id?: string
  action?: string
  action_type?: string
  start_date?: string
  end_date?: string
  limit?: number
  offset?: number
}

/**
 * Get paginated audit trail entries with optional filters
 */
export async function getAuditTrail(filters: AuditTrailFilters = {}): Promise<AuditTrailResponse> {
  const params = new URLSearchParams()

  if (filters.resource_type) params.append("resource_type", filters.resource_type)
  if (filters.resource_id) params.append("resource_id", filters.resource_id)
  if (filters.user_id) params.append("user_id", filters.user_id)
  if (filters.action) params.append("action", filters.action)
  if (filters.action_type) params.append("action_type", filters.action_type)
  if (filters.start_date) params.append("start_date", filters.start_date)
  if (filters.end_date) params.append("end_date", filters.end_date)
  if (filters.limit) params.append("limit", String(filters.limit))
  if (filters.offset) params.append("offset", String(filters.offset))

  const queryString = params.toString()
  const url = queryString ? `/admin/audit?${queryString}` : "/admin/audit"
  const response = await api.get(url)
  return response.data || response
}

/**
 * Get aggregated audit statistics by action type
 */
export async function getAuditStats(
  startDate?: string,
  endDate?: string
): Promise<AuditStatsResponse> {
  const params = new URLSearchParams()
  if (startDate) params.append("start_date", startDate)
  if (endDate) params.append("end_date", endDate)

  const queryString = params.toString()
  const url = queryString ? `/admin/audit/stats?${queryString}` : "/admin/audit/stats"
  const response = await api.get(url)
  return response.data || response
}
